export const HKDSE_MATHS_MC_2012 = {
  year: 2012,
  title: "HKDSE 數學科 多項選擇題 2012",
  totalQuestions: 45,
  timeLimit: 120, // minutes
  questions: [
    {
      id: "2012Q001",
      questionNumber: 1,
      question: "化簡 $2^3 \\times 2^5 =$",
      options: [
        { id: "A", text: "$2^8$" },
        { id: "B", text: "$2^{15}$" },
        { id: "C", text: "$4^8$" },
        { id: "D", text: "$4^{15}$" }
      ],
      correctAnswer: "A",
      solution: "$2^3 \\times 2^5 = 2^{3+5} = 2^8$",
      topic: "指數運算",
      difficulty: "基礎"
    },
    {
      id: "2012Q002",
      questionNumber: 2,
      question: "若 $4x + 3y = 24$，則 $x =$",
      options: [
        { id: "A", text: "$\\frac{24 - 3y}{4}$" },
        { id: "B", text: "$\\frac{24 + 3y}{4}$" },
        { id: "C", text: "$24 - 3y$" },
        { id: "D", text: "$\\frac{3y - 24}{4}$" }
      ],
      correctAnswer: "A",
      solution: "$4x + 3y = 24$\n$4x = 24 - 3y$\n$x = \\frac{24 - 3y}{4}$",
      topic: "代數式重排",
      difficulty: "基礎"
    },
    {
      id: "2012Q003",
      questionNumber: 3,
      question: "計算 $\\frac{5}{x+2} + \\frac{3}{x-1} =$",
      options: [
        { id: "A", text: "$\\frac{8x - 1}{(x+2)(x-1)}$" },
        { id: "B", text: "$\\frac{8x + 1}{(x+2)(x-1)}$" },
        { id: "C", text: "$\\frac{5x - 5 + 3x + 6}{(x+2)(x-1)}$" },
        { id: "D", text: "$\\frac{8}{2x + 1}$" }
      ],
      correctAnswer: "B",
      solution: "$\\frac{5}{x+2} + \\frac{3}{x-1} = \\frac{5(x-1) + 3(x+2)}{(x+2)(x-1)}$\n$= \\frac{5x - 5 + 3x + 6}{(x+2)(x-1)} = \\frac{8x + 1}{(x+2)(x-1)}$",
      topic: "分式運算",
      difficulty: "中級"
    },
    {
      id: "2012Q004",
      questionNumber: 4,
      question: "因式分解 $x^2 - 6x + 9 =$",
      options: [
        { id: "A", text: "$(x - 3)^2$" },
        { id: "B", text: "$(x + 3)^2$" },
        { id: "C", text: "$(x - 3)(x + 3)$" },
        { id: "D", text: "$(x - 9)(x + 1)$" }
      ],
      correctAnswer: "A",
      solution: "$x^2 - 6x + 9 = x^2 - 2 \\cdot 3 \\cdot x + 3^2 = (x - 3)^2$\n這是完全平方式：$a^2 - 2ab + b^2 = (a - b)^2$",
      topic: "因式分解",
      difficulty: "基礎"
    },
    {
      id: "2012Q005",
      questionNumber: 5,
      question: "若 $h(x) = 3x - 5$，則 $h(4) - h(1) =$",
      options: [
        { id: "A", text: "$7$" },
        { id: "B", text: "$9$" },
        { id: "C", text: "$11$" },
        { id: "D", text: "$15$" }
      ],
      correctAnswer: "B",
      solution: "$h(4) = 3(4) - 5 = 12 - 5 = 7$\n$h(1) = 3(1) - 5 = 3 - 5 = -2$\n$h(4) - h(1) = 7 - (-2) = 7 + 2 = 9$",
      topic: "函數運算",
      difficulty: "基礎"
    },
    {
      id: "2012Q006",
      questionNumber: 6,
      question: "解方程 $x^2 + 7x = 0$",
      options: [
        { id: "A", text: "$x = 0$" },
        { id: "B", text: "$x = 7$" },
        { id: "C", text: "$x = 0$ 或 $x = -7$" },
        { id: "D", text: "$x = 0$ 或 $x = 7$" }
      ],
      correctAnswer: "C",
      solution: "$x^2 + 7x = 0$\n$x(x + 7) = 0$\n$x = 0$ 或 $x + 7 = 0$\n$x = 0$ 或 $x = -7$",
      topic: "二次方程",
      difficulty: "基礎"
    },
    {
      id: "2012Q007",
      questionNumber: 7,
      question: "二次方程 $x^2 + 6x + k = 0$ 有兩個相等實根，則 $k =$",
      options: [
        { id: "A", text: "$3$" },
        { id: "B", text: "$6$" },
        { id: "C", text: "$9$" },
        { id: "D", text: "$36$" }
      ],
      correctAnswer: "C",
      solution: "兩個相等實根時，判別式 $\\Delta = 0$\n$\\Delta = 6^2 - 4(1)(k) = 36 - 4k$\n$36 - 4k = 0$\n$4k = 36$\n$k = 9$",
      topic: "判別式",
      difficulty: "中級"
    },
    {
      id: "2012Q008",
      questionNumber: 8,
      question: "某商品原價 $\\$300$，先減價 $20\\%$，後加價 $15\\%$。最終售價為",
      options: [
        { id: "A", text: "$\\$276$" },
        { id: "B", text: "$\\$285$" },
        { id: "C", text: "$\\$295$" },
        { id: "D", text: "$\\$345$" }
      ],
      correctAnswer: "A",
      solution: "原價：$\\$300$\n減價後：$300 \\times (1 - 0.2) = 300 \\times 0.8 = \\$240$\n加價後：$240 \\times (1 + 0.15) = 240 \\times 1.15 = \\$276$",
      topic: "百分比",
      difficulty: "中級"
    },
    {
      id: "2012Q009",
      questionNumber: 9,
      question: "本金 $\\$10000$，年利率 $4\\%$，複利計算 $3$ 年。本利和為",
      options: [
        { id: "A", text: "$\\$11248.64$" },
        { id: "B", text: "$\\$11200$" },
        { id: "C", text: "$\\$12000$" },
        { id: "D", text: "$\\$11248$" }
      ],
      correctAnswer: "A",
      solution: "複利公式：$A = P(1 + r)^n$\n$A = 10000(1 + 0.04)^3 = 10000(1.04)^3$\n$(1.04)^3 = 1.124864$\n$A = 10000 \\times 1.124864 = \\$11248.64$",
      topic: "複利計算",
      difficulty: "中級"
    },
    {
      id: "2012Q010",
      questionNumber: 10,
      question: "等差數列 $5, 9, 13, 17, \\ldots$ 的第 $12$ 項為",
      options: [
        { id: "A", text: "$49$" },
        { id: "B", text: "$53$" },
        { id: "C", text: "$57$" },
        { id: "D", text: "$61$" }
      ],
      correctAnswer: "A",
      solution: "首項 $a_1 = 5$，公差 $d = 9 - 5 = 4$\n第 $n$ 項公式：$a_n = a_1 + (n-1)d$\n$a_{12} = 5 + (12-1) \\times 4 = 5 + 11 \\times 4 = 5 + 44 = 49$",
      topic: "等差數列",
      difficulty: "基礎"
    },
    {
      id: "2012Q011",
      questionNumber: 11,
      question: "若 $m:n = 4:5$ 且 $n:p = 3:7$，則 $m:p =$",
      options: [
        { id: "A", text: "$4:7$" },
        { id: "B", text: "$12:35$" },
        { id: "C", text: "$12:7$" },
        { id: "D", text: "$4:35$" }
      ],
      correctAnswer: "B",
      solution: "$m:n = 4:5$，所以 $m = \\frac{4n}{5}$\n$n:p = 3:7$，所以 $p = \\frac{7n}{3}$\n$m:p = \\frac{4n}{5} : \\frac{7n}{3} = \\frac{4n}{5} \\times \\frac{3}{7n} = \\frac{12}{35}$\n因此 $m:p = 12:35$",
      topic: "比例",
      difficulty: "中級"
    },
    {
      id: "2012Q012",
      questionNumber: 12,
      question: "若 $y$ 隨 $x$ 反變，且當 $x = 8$ 時 $y = 3$。則當 $x = 6$ 時，$y =$",
      options: [
        { id: "A", text: "$2$" },
        { id: "B", text: "$4$" },
        { id: "C", text: "$\\frac{9}{4}$" },
        { id: "D", text: "$\\frac{16}{3}$" }
      ],
      correctAnswer: "B",
      solution: "$y$ 隨 $x$ 反變：$y = \\frac{k}{x}$\n當 $x = 8$，$y = 3$：$3 = \\frac{k}{8}$，所以 $k = 24$\n因此 $y = \\frac{24}{x}$\n當 $x = 6$ 時：$y = \\frac{24}{6} = 4$",
      topic: "反變",
      difficulty: "基礎"
    },
    {
      id: "2012Q013",
      questionNumber: 13,
      question: "地圖比例尺為 $1:200000$。若兩地實際距離為 $15$ km，在地圖上的距離為",
      options: [
        { id: "A", text: "$7.5$ cm" },
        { id: "B", text: "$15$ cm" },
        { id: "C", text: "$30$ cm" },
        { id: "D", text: "$75$ cm" }
      ],
      correctAnswer: "A",
      solution: "實際距離 $15$ km $= 15000$ m $= 1500000$ cm\n比例尺 $1:200000$ 表示實際 $200000$ cm 對應地圖 $1$ cm\n地圖距離 = $\\frac{1500000}{200000} = 7.5$ cm",
      topic: "比例尺",
      difficulty: "基礎"
    },
    {
      id: "2012Q014",
      questionNumber: 14,
      question: "從西向北測得某點的方位角為 $35°$，則從該點向西測得的方位角為",
      options: [
        { id: "A", text: "N$55°$W" },
        { id: "B", text: "S$35°$E" },
        { id: "C", text: "S$55°$E" },
        { id: "D", text: "N$35°$E" }
      ],
      correctAnswer: "C",
      solution: "從西向北 $35°$ 表示該點在觀測者的西北方向\n從該點回望觀測者，觀測者在該點的東南方向\n角度關係：從南向東 $90° - 35° = 55°$\n因此方位角為 S$55°$E",
      topic: "方位角",
      difficulty: "中級"
    },
    {
      id: "2012Q015",
      questionNumber: 15,
      question: "菱形的對角線長分別為 $8$ cm 和 $6$ cm。面積為",
      options: [
        { id: "A", text: "$24$ cm²" },
        { id: "B", text: "$28$ cm²" },
        { id: "C", text: "$48$ cm²" },
        { id: "D", text: "$96$ cm²" }
      ],
      correctAnswer: "A",
      solution: "菱形面積公式：$A = \\frac{1}{2} \\times d_1 \\times d_2$\n其中 $d_1 = 8$ cm，$d_2 = 6$ cm\n$A = \\frac{1}{2} \\times 8 \\times 6 = 24$ cm²",
      topic: "面積計算",
      difficulty: "基礎"
    },
    {
      id: "2012Q016",
      questionNumber: 16,
      question: "圓柱體的底直徑 $8$ cm，高 $10$ cm。體積為",
      options: [
        { id: "A", text: "$160\\pi$ cm³" },
        { id: "B", text: "$320\\pi$ cm³" },
        { id: "C", text: "$640\\pi$ cm³" },
        { id: "D", text: "$80\\pi$ cm³" }
      ],
      correctAnswer: "A",
      solution: "圓柱體積公式：$V = \\pi r^2 h$\n底直徑 $= 8$ cm，所以半徑 $r = 4$ cm，高 $h = 10$ cm\n$V = \\pi \\times 4^2 \\times 10 = \\pi \\times 16 \\times 10 = 160\\pi$ cm³",
      topic: "體積計算",
      difficulty: "基礎"
    },
    {
      id: "2012Q017",
      questionNumber: 17,
      question: "球體直徑 $12$ cm。體積為",
      options: [
        { id: "A", text: "$288\\pi$ cm³" },
        { id: "B", text: "$864\\pi$ cm³" },
        { id: "C", text: "$1728\\pi$ cm³" },
        { id: "D", text: "$2304\\pi$ cm³" }
      ],
      correctAnswer: "A",
      solution: "球體體積公式：$V = \\frac{4}{3}\\pi r^3$\n直徑 $= 12$ cm，所以半徑 $r = 6$ cm\n$V = \\frac{4}{3}\\pi \\times 6^3 = \\frac{4}{3}\\pi \\times 216 = \\frac{864\\pi}{3} = 288\\pi$ cm³",
      topic: "體積計算",
      difficulty: "中級"
    },
    {
      id: "2012Q018",
      questionNumber: 18,
      question: "扇形的半徑 $20$ cm，圓心角 $45°$。弧長為",
      options: [
        { id: "A", text: "$5\\pi$ cm" },
        { id: "B", text: "$10\\pi$ cm" },
        { id: "C", text: "$15\\pi$ cm" },
        { id: "D", text: "$20\\pi$ cm" }
      ],
      correctAnswer: "A",
      solution: "弧長公式：$l = \\frac{\\theta}{360°} \\times 2\\pi r$\n其中 $r = 20$ cm，$\\theta = 45°$\n$l = \\frac{45°}{360°} \\times 2\\pi \\times 20 = \\frac{1}{8} \\times 40\\pi = 5\\pi$ cm",
      topic: "弧長計算",
      difficulty: "基礎"
    },
    {
      id: "2012Q019",
      questionNumber: 19,
      question: "圓錐的底半徑 $3$ cm，高 $4$ cm。母線長為",
      options: [
        { id: "A", text: "$5$ cm" },
        { id: "B", text: "$7$ cm" },
        { id: "C", text: "$12$ cm" },
        { id: "D", text: "$25$ cm" }
      ],
      correctAnswer: "A",
      solution: "母線長 = $\\sqrt{半徑^2 + 高^2}$（畢達哥拉斯定理）\n母線長 = $\\sqrt{3^2 + 4^2} = \\sqrt{9 + 16} = \\sqrt{25} = 5$ cm",
      topic: "立體幾何",
      difficulty: "中級"
    },
    {
      id: "2012Q020",
      questionNumber: 20,
      question: "扇形的半徑為 $15$ cm，弧長為 $10\\pi$ cm，此扇形屈成圓錐時，圓錐底面半徑為",
      options: [
        { id: "A", text: "$3$ cm" },
        { id: "B", text: "$5$ cm" },
        { id: "C", text: "$7$ cm" },
        { id: "D", text: "$10$ cm" }
      ],
      correctAnswer: "B",
      solution: "扇形屈成圓錐時：\n扇形弧長 = 圓錐底面周長\n$10\\pi = 2\\pi r$\n$r = \\frac{10\\pi}{2\\pi} = 5$ cm",
      topic: "圓錐展開",
      difficulty: "中級"
    },
    {
      id: "2012Q021",
      questionNumber: 21,
      question: "$\\tan 45° + \\cot 45° =$",
      options: [
        { id: "A", text: "$1$" },
        { id: "B", text: "$2$" },
        { id: "C", text: "$\\sqrt{2}$" },
        { id: "D", text: "$\\frac{\\sqrt{2}}{2}$" }
      ],
      correctAnswer: "B",
      solution: "$\\tan 45° = 1$\n$\\cot 45° = \\frac{1}{\\tan 45°} = \\frac{1}{1} = 1$\n$\\tan 45° + \\cot 45° = 1 + 1 = 2$",
      topic: "三角函數值",
      difficulty: "基礎"
    },
    {
      id: "2012Q022",
      questionNumber: 22,
      question: "若 $\\cos \\beta = \\frac{4}{5}$，且 $\\beta$ 為銳角，則 $\\sin \\beta =$",
      options: [
        { id: "A", text: "$\\frac{3}{5}$" },
        { id: "B", text: "$\\frac{4}{3}$" },
        { id: "C", text: "$\\frac{5}{3}$" },
        { id: "D", text: "$\\frac{5}{4}$" }
      ],
      correctAnswer: "A",
      solution: "使用畢達哥拉斯定理：$\\sin^2 \\beta + \\cos^2 \\beta = 1$\n$\\sin^2 \\beta + \\left(\\frac{4}{5}\\right)^2 = 1$\n$\\sin^2 \\beta + \\frac{16}{25} = 1$\n$\\sin^2 \\beta = 1 - \\frac{16}{25} = \\frac{9}{25}$\n$\\sin \\beta = \\frac{3}{5}$（$\\beta$ 為銳角，$\\sin \\beta > 0$）",
      topic: "三角函數關係",
      difficulty: "中級"
    },
    {
      id: "2012Q023",
      questionNumber: 23,
      question: "化簡 $\\sin \\theta \\csc \\theta =$",
      options: [
        { id: "A", text: "$0$" },
        { id: "B", text: "$1$" },
        { id: "C", text: "$\\sin \\theta$" },
        { id: "D", text: "$\\cos \\theta$" }
      ],
      correctAnswer: "B",
      solution: "$\\sin \\theta \\csc \\theta = \\sin \\theta \\times \\frac{1}{\\sin \\theta} = 1$\n（其中 $\\csc \\theta = \\frac{1}{\\sin \\theta}$）",
      topic: "三角恆等式",
      difficulty: "基礎"
    },
    {
      id: "2012Q024",
      questionNumber: 24,
      question: "在直角三角形中，若一銳角為 $60°$，鄰邊長為 $8$，則對邊長為",
      options: [
        { id: "A", text: "$4\\sqrt{3}$" },
        { id: "B", text: "$8\\sqrt{3}$" },
        { id: "C", text: "$16$" },
        { id: "D", text: "$4$" }
      ],
      correctAnswer: "B",
      solution: "在直角三角形中：$\\tan 60° = \\frac{對邊}{鄰邊}$\n$\\tan 60° = \\sqrt{3}$\n對邊 = 鄰邊 $\\times \\tan 60° = 8 \\times \\sqrt{3} = 8\\sqrt{3}$",
      topic: "三角函數應用",
      difficulty: "中級"
    },
    {
      id: "2012Q025",
      questionNumber: 25,
      question: "圖中，正四面體的一條棱與底面的夾角為",
      options: [
        { id: "A", text: "$\\arccos \\frac{1}{3}$" },
        { id: "B", text: "$\\arccos \\frac{\\sqrt{3}}{3}$" },
        { id: "C", text: "$\\arccos \\frac{2}{3}$" },
        { id: "D", text: "$\\arccos \\frac{\\sqrt{6}}{3}$" }
      ],
      correctAnswer: "B",
      solution: "在正四面體中，棱與底面的夾角的餘弦值為 $\\frac{\\sqrt{3}}{3}$\n因此夾角為 $\\arccos \\frac{\\sqrt{3}}{3}$",
      topic: "立體幾何角度",
      difficulty: "高級",
      hasImage: true,
      imageDescription: "正四面體，標示棱與底面的夾角"
    },
    {
      id: "2012Q026",
      questionNumber: 26,
      question: "圖中，點 $P(2, 3)$ 經過關於 $y = x$ 的反射後得到點 $P'$。$P'$ 的坐標為",
      options: [
        { id: "A", text: "$(3, 2)$" },
        { id: "B", text: "$(-2, -3)$" },
        { id: "C", text: "$(2, -3)$" },
        { id: "D", text: "$(-3, 2)$" }
      ],
      correctAnswer: "A",
      solution: "關於直線 $y = x$ 的反射：$(x, y) \\rightarrow (y, x)$\n點 $P(2, 3)$ 反射後得到 $P'(3, 2)$",
      topic: "幾何變換",
      difficulty: "基礎",
      hasImage: true,
      imageDescription: "坐標平面上點P及其關於y=x的反射點P'"
    },
    {
      id: "2012Q027",
      questionNumber: 27,
      question: "圖中，$\\triangle ABC \\sim \\triangle PQR$。若 $AB = 12$ cm，$PQ = 8$ cm，$AC = 15$ cm，則 $PR =$",
      options: [
        { id: "A", text: "$10$ cm" },
        { id: "B", text: "$18$ cm" },
        { id: "C", text: "$20$ cm" },
        { id: "D", text: "$22.5$ cm" }
      ],
      correctAnswer: "A",
      solution: "相似三角形對應邊成比例：\n$\\frac{AB}{PQ} = \\frac{AC}{PR}$\n$\\frac{12}{8} = \\frac{15}{PR}$\n$\\frac{3}{2} = \\frac{15}{PR}$\n$PR = \\frac{15 \\times 2}{3} = 10$ cm",
      topic: "相似三角形",
      difficulty: "基礎",
      hasImage: true,
      imageDescription: "兩個相似三角形ABC和PQR，標示對應邊長"
    },
    {
      id: "2012Q028",
      questionNumber: 28,
      question: "點 $C(0, -5)$ 在極坐標系中的坐標為",
      options: [
        { id: "A", text: "$(5, 270°)$" },
        { id: "B", text: "$(5, -90°)$" },
        { id: "C", text: "$(5, 90°)$" },
        { id: "D", text: "$(5, 180°)$" }
      ],
      correctAnswer: "A",
      solution: "極坐標 $(r, \\theta)$：\n$r = \\sqrt{0^2 + (-5)^2} = \\sqrt{25} = 5$\n點在負 $y$ 軸上，$\\theta = 270°$\n因此極坐標為 $(5, 270°)$",
      topic: "極坐標",
      difficulty: "中級"
    },
    {
      id: "2012Q029",
      questionNumber: 29,
      question: "直線 $5x - 2y = 10$ 的斜率為",
      options: [
        { id: "A", text: "$\\frac{5}{2}$" },
        { id: "B", text: "$-\\frac{5}{2}$" },
        { id: "C", text: "$\\frac{2}{5}$" },
        { id: "D", text: "$-\\frac{2}{5}$" }
      ],
      correctAnswer: "A",
      solution: "將方程轉換為斜率截距形式：$y = mx + c$\n$5x - 2y = 10$\n$-2y = -5x + 10$\n$y = \\frac{5}{2}x - 5$\n斜率 $m = \\frac{5}{2}$",
      topic: "直線斜率",
      difficulty: "基礎"
    },
    {
      id: "2012Q030",
      questionNumber: 30,
      question: "與直線 $y = \\frac{2}{3}x - 1$ 平行且通過點 $(6, 4)$ 的直線方程為",
      options: [
        { id: "A", text: "$y = \\frac{2}{3}x$" },
        { id: "B", text: "$y = \\frac{2}{3}x + 4$" },
        { id: "C", text: "$y = \\frac{2}{3}x - 4$" },
        { id: "D", text: "$y = -\\frac{3}{2}x + 13$" }
      ],
      correctAnswer: "A",
      solution: "平行直線有相同斜率 $m = \\frac{2}{3}$\n通過點 $(6, 4)$ 的直線方程：$y - 4 = \\frac{2}{3}(x - 6)$\n$y - 4 = \\frac{2}{3}x - 4$\n$y = \\frac{2}{3}x$",
      topic: "平行直線",
      difficulty: "中級"
    },
    {
      id: "2012Q031",
      questionNumber: 31,
      question: "線段 $EF$ 的端點為 $E(-1, 4)$ 和 $F(5, -2)$，其中點坐標為",
      options: [
        { id: "A", text: "$(2, 1)$" },
        { id: "B", text: "$(3, 1)$" },
        { id: "C", text: "$(2, 3)$" },
        { id: "D", text: "$(4, 2)$" }
      ],
      correctAnswer: "A",
      solution: "中點公式：$M = \\left(\\frac{x_1 + x_2}{2}, \\frac{y_1 + y_2}{2}\\right)$\n$M = \\left(\\frac{-1 + 5}{2}, \\frac{4 + (-2)}{2}\\right) = \\left(\\frac{4}{2}, \\frac{2}{2}\\right) = (2, 1)$",
      topic: "中點坐標",
      difficulty: "基礎"
    },
    {
      id: "2012Q032",
      questionNumber: 32,
      question: "正八邊形的內角和為",
      options: [
        { id: "A", text: "$1080°$" },
        { id: "B", text: "$1260°$" },
        { id: "C", text: "$1440°$" },
        { id: "D", text: "$1620°$" }
      ],
      correctAnswer: "A",
      solution: "$n$ 邊形內角和公式：$(n - 2) \\times 180°$\n正八邊形：$n = 8$\n內角和 = $(8 - 2) \\times 180° = 6 \\times 180° = 1080°$",
      topic: "正多邊形",
      difficulty: "基礎"
    },
    {
      id: "2012Q033",
      questionNumber: 33,
      question: "從一副標準撲克牌（52張）中抽取一張，抽到紅桃的概率為",
      options: [
        { id: "A", text: "$\\frac{1}{13}$" },
        { id: "B", text: "$\\frac{1}{4}$" },
        { id: "C", text: "$\\frac{1}{2}$" },
        { id: "D", text: "$\\frac{3}{4}$" }
      ],
      correctAnswer: "B",
      solution: "標準撲克牌有4種花色：紅桃、方塊、黑桃、梅花\n每種花色有13張牌\n紅桃有13張，總共52張\n概率 = $\\frac{13}{52} = \\frac{1}{4}$",
      topic: "概率基本性質",
      difficulty: "基礎"
    },
    {
      id: "2012Q034",
      questionNumber: 34,
      question: "投擲一顆公平骰子兩次，兩次點數之積為偶數的概率為",
      options: [
        { id: "A", text: "$\\frac{1}{4}$" },
        { id: "B", text: "$\\frac{1}{2}$" },
        { id: "C", text: "$\\frac{3}{4}$" },
        { id: "D", text: "$\\frac{5}{6}$" }
      ],
      correctAnswer: "C",
      solution: "積為偶數當且僅當至少有一次投出偶數\n反面：積為奇數當且僅當兩次都投出奇數\n奇數：1, 3, 5（3個），偶數：2, 4, 6（3個）\n兩次都奇數的概率 = $\\frac{3}{6} \\times \\frac{3}{6} = \\frac{1}{4}$\n積為偶數的概率 = $1 - \\frac{1}{4} = \\frac{3}{4}$",
      topic: "概率",
      difficulty: "中級"
    },
    {
      id: "2012Q035",
      questionNumber: 35,
      question: "某班學生身高的平均數為 $165$ cm，標準差為 $5$ cm。若所有身高都減去 $10$ cm，新的平均數和標準差分別為",
      options: [
        { id: "A", text: "$155$ cm, $5$ cm" },
        { id: "B", text: "$165$ cm, $5$ cm" },
        { id: "C", text: "$155$ cm, $15$ cm" },
        { id: "D", text: "$155$ cm, $-5$ cm" }
      ],
      correctAnswer: "A",
      solution: "所有數據減去常數 $k$：\n新平均數 = 原平均數 - $k = 165 - 10 = 155$ cm\n新標準差 = 原標準差（不變）$= 5$ cm",
      topic: "統計量",
      difficulty: "中級"
    },
    {
      id: "2012Q036",
      questionNumber: 36,
      question: "某組數據的第一四分位數為 $15$，第三四分位數為 $25$，中位數為 $20$。若最小值為 $10$，最大值為 $30$，則箱線圖中箱子的長度為",
      options: [
        { id: "A", text: "$5$" },
        { id: "B", text: "$10$" },
        { id: "C", text: "$15$" },
        { id: "D", text: "$20$" }
      ],
      correctAnswer: "B",
      solution: "箱線圖中箱子的長度 = 第三四分位數 - 第一四分位數\n$= 25 - 15 = 10$",
      topic: "箱線圖",
      difficulty: "基礎"
    },
    {
      id: "2012Q037",
      questionNumber: 37,
      question: "散點圖顯示兩變數的相關係數為 $-0.92$，這表示",
      options: [
        { id: "A", text: "強正相關" },
        { id: "B", text: "弱正相關" },
        { id: "C", text: "強負相關" },
        { id: "D", text: "弱負相關" }
      ],
      correctAnswer: "C",
      solution: "相關係數 $r = -0.92 < 0$，表示負相關\n$|r| = 0.92 > 0.7$，表示強相關\n因此為強負相關",
      topic: "散點圖",
      difficulty: "基礎"
    },
    {
      id: "2012Q038",
      questionNumber: 38,
      question: "$3^{-2} \\times 9^2 =$",
      options: [
        { id: "A", text: "$1$" },
        { id: "B", text: "$3$" },
        { id: "C", text: "$9$" },
        { id: "D", text: "$27$" }
      ],
      correctAnswer: "C",
      solution: "$3^{-2} = \\frac{1}{3^2} = \\frac{1}{9}$\n$9^2 = (3^2)^2 = 3^4 = 81$\n$3^{-2} \\times 9^2 = \\frac{1}{9} \\times 81 = 9$",
      topic: "指數運算",
      difficulty: "中級"
    },
    {
      id: "2012Q039",
      questionNumber: 39,
      question: "指數函數 $y = 2^{x-1}$ 的圖像通過點",
      options: [
        { id: "A", text: "$(0, \\frac{1}{2})$" },
        { id: "B", text: "$(1, 1)$" },
        { id: "C", text: "$(2, 2)$" },
        { id: "D", text: "$(-1, \\frac{1}{4})$" }
      ],
      correctAnswer: "B",
      solution: "檢查各選項：\n$(1, 1)$：$y = 2^{1-1} = 2^0 = 1$ ✓\n因此函數通過點 $(1, 1)$",
      topic: "指數函數",
      difficulty: "基礎"
    },
    {
      id: "2012Q040",
      questionNumber: 40,
      question: "$\\log_5 125 + \\log_5 5 =$",
      options: [
        { id: "A", text: "$3$" },
        { id: "B", text: "$4$" },
        { id: "C", text: "$5$" },
        { id: "D", text: "$25$" }
      ],
      correctAnswer: "B",
      solution: "$\\log_5 125 = \\log_5 5^3 = 3$\n$\\log_5 5 = 1$\n$\\log_5 125 + \\log_5 5 = 3 + 1 = 4$",
      topic: "對數運算",
      difficulty: "基礎"
    },
    {
      id: "2012Q041",
      questionNumber: 41,
      question: "將八進位數 $37_8$ 轉換為十進位數為",
      options: [
        { id: "A", text: "$31$" },
        { id: "B", text: "$37$" },
        { id: "C", text: "$55$" },
        { id: "D", text: "$59$" }
      ],
      correctAnswer: "A",
      solution: "$37_8 = 3 \\times 8^1 + 7 \\times 8^0 = 3 \\times 8 + 7 \\times 1 = 24 + 7 = 31$",
      topic: "進位制轉換",
      difficulty: "中級"
    },
    {
      id: "2012Q042",
      questionNumber: 42,
      question: "多項式 $x^3 - 3x^2 + 2x - 6$ 除以 $(x - 3)$ 的餘數為",
      options: [
        { id: "A", text: "$0$" },
        { id: "B", text: "$-6$" },
        { id: "C", text: "$6$" },
        { id: "D", text: "$12$" }
      ],
      correctAnswer: "A",
      solution: "使用餘數定理：$f(x) = x^3 - 3x^2 + 2x - 6$\n餘數 = $f(3) = 3^3 - 3(3^2) + 2(3) - 6$\n$= 27 - 27 + 6 - 6 = 0$",
      topic: "餘數定理",
      difficulty: "中級"
    },
    {
      id: "2012Q043",
      questionNumber: 43,
      question: "不等式 $5x - 2 > 3x + 4$ 的解為",
      options: [
        { id: "A", text: "$x > 3$" },
        { id: "B", text: "$x < 3$" },
        { id: "C", text: "$x > -3$" },
        { id: "D", text: "$x < -3$" }
      ],
      correctAnswer: "A",
      solution: "$5x - 2 > 3x + 4$\n$5x - 3x > 4 + 2$\n$2x > 6$\n$x > 3$",
      topic: "一元不等式",
      difficulty: "基礎"
    },
    {
      id: "2012Q044",
      questionNumber: 44,
      question: "等比數列 $\\{b_n\\}$ 中，$b_1 = 3$，$r = 2$。前 $6$ 項和為",
      options: [
        { id: "A", text: "$189$" },
        { id: "B", text: "$192$" },
        { id: "C", text: "$195$" },
        { id: "D", text: "$198$" }
      ],
      correctAnswer: "A",
      solution: "等比數列前 $n$ 項和公式：$S_n = a_1 \\frac{r^n - 1}{r - 1}$\n$S_6 = 3 \\times \\frac{2^6 - 1}{2 - 1} = 3 \\times \\frac{64 - 1}{1} = 3 \\times 63 = 189$",
      topic: "等比數列",
      difficulty: "中級"
    },
    {
      id: "2012Q045",
      questionNumber: 45,
      question: "圓 $x^2 + y^2 - 4x + 6y - 12 = 0$ 的圓心坐標為",
      options: [
        { id: "A", text: "$(2, -3)$" },
        { id: "B", text: "$(-2, 3)$" },
        { id: "C", text: "$(4, -6)$" },
        { id: "D", text: "$(-4, 6)$" }
      ],
      correctAnswer: "A",
      solution: "圓的一般方程：$x^2 + y^2 - 4x + 6y - 12 = 0$\n配方：$(x^2 - 4x) + (y^2 + 6y) = 12$\n$(x^2 - 4x + 4) + (y^2 + 6y + 9) = 12 + 4 + 9$\n$(x - 2)^2 + (y + 3)^2 = 25$\n圓心坐標為 $(2, -3)$",
      topic: "圓的方程",
      difficulty: "中級"
    }
  ],
  topics: [
    "指數運算", "代數式重排", "分式運算", "因式分解", "函數運算", "二次方程", "判別式", "百分比", "複利計算", "等差數列", "比例", "反變", "比例尺", "方位角", "面積計算", "體積計算", "弧長計算", "立體幾何", "圓錐展開", "三角函數值", "三角函數關係", "三角恆等式", "三角函數應用", "立體幾何角度", "幾何變換", "相似三角形", "極坐標", "直線斜率", "平行直線", "中點坐標", "正多邊形", "概率基本性質", "概率", "統計量", "箱線圖", "散點圖", "對數運算", "進位制轉換", "餘數定理", "一元不等式", "等比數列", "圓的方程"
  ],
  statistics: {
    totalMarks: 45,
    passingMark: 23,
    averageScore: 28.5,
    difficulty: {
      basic: 20,
      intermediate: 20,
      advanced: 5
    }
  }
}; 